import { gql } from "@apollo/client"

export const GET_MEMBERS = gql`
  query GetMembers($userId: ID!, $type: String!) {
    getMembers(user_id: $userId, type: $type) {
      id
      first_name
      last_name
      profile_member_id
      balance
      profile_name
      email
    }
  }
`